import { useCallback, useEffect } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import { Alert } from "@dealer-center/core-components";
import type { ControlcenterAPIInterfaceExternal } from "@dealer-center/ddc-pages-controlcenter-interface";
import type { decodedJwtAndPermissions } from "@dealer-center/ddc-api-user-interface";
import { Locale } from "@dealer-center/ddc-core-utils";
import LABELS from "./labels.json";
import { WIDGET, getURLparameter } from "./utils/utils";
import "./AccountAssets.scss";
import { GetPresigned } from "./components/GetPresigned";

export const AccountAssets = (): React.ReactElement => {
  const { asAccount, asUser } = useParams<{
    asAccount: string;
    asUser: string;
  }>();
  const path = getURLparameter("path") || "dealerphoto";
  const { ccUserInfo, userEntity } = useOutletContext<{
    ccUserInfo: ControlcenterAPIInterfaceExternal;
    userEntity: decodedJwtAndPermissions;
  }>();

  const hideHeaders = useCallback(() => {
    ["cc8-header", "bridge-bar"].forEach(tag => {
      const element = document.querySelector(tag);
      if (element) {
        element.classList.add("hideHeaders");
      }
    });
  }, []);

  useEffect(() => {
    if (WIDGET) {
      hideHeaders();

      const observer = new MutationObserver(() => {
        hideHeaders();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      return () => observer.disconnect();
    }
    return undefined;
  }, [hideHeaders]);

  Locale.setLabelsOnce(LABELS);

  if (!asAccount || !asUser || !userEntity.internal) {
    return (
      <Alert role="alert" sx={{ marginBottom: "16px" }} type="error">
        {Locale.getText("ACCOUNTASSETS_NO_ACCESS") as string}
      </Alert>
    );
  }

  console.log(`in AccountAssets, path=${path}`);

  return (
    <div className="account-assets-container">
      <GetPresigned path={path} />
    </div>
  );
};
